import React from "react";
import { useEffect, useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
// import AttachFile from "@material-ui/icons/AttachFile";
import axios from "axios";

const YOUR_PRIVATE_KEY = "6Le3utQhAAAAAKR-L_9-laElwYvGEqxDWSBOMRps";

const ClaimForm = () => {
  const [Captcha, setCaptcha] = useState(null);

  const onChange = (value) => {
    setCaptcha(value);
    console.log("Captcha value:", value);
  };

  const submitHandler = async () => {
    if (Captcha == null) {
      alert("please verify code");
      return;
    }

    const res = await axios.post(
      `https://www.google.com/recaptcha/api/siteverify?secret=${YOUR_PRIVATE_KEY}&response=${Captcha}`
    );

    // Extract result from the API response
    if (res.data.success) console.log("Human");
    else console.log("BOT!!!");
  };

  return (
    <div>
      <div className="bg-[#efefef] flex flex-col justify-center items-center h-[150px]">
        <h1 className="text-[40px] font-bold">Claim Registration Form</h1>
      </div>
      {/* <!-- Heading --> */}
      {/* <!-- Form --> */}
      <div className="my-[3rem]">
        <div className="flex flex-col justify-center items-center mt-[1rem] ">
          <div className="flex flex-col gap-3 p-8 mb-3 shadow-card text-sm w-[45rem] rounded-md transition-all duration-500">
            <h2 className="font-bold text-[1.1rem]">
              Your Consignment Details
            </h2>
            <div className="flex gap-4 mt-4">
              <div className="flex-1 flex flex-col gap-4">
                <div className="flex gap-4">
                  <div className="MuiFormControl-root MuiTextField-root flex-1">
                    <div className="relative">
                      <input
                        type="Number"
                        id="floating_outlined"
                        className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                        placeholder=" "
                      />
                      <label
                        for="floating_outlined"
                        className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                      >
                        Consignment #
                      </label>
                    </div>
                  </div>
                  <div
                    className="MuiFormControl-root flex-1"
                    inputprops="[object Object]"
                    inputlabelprops="[object Object]"
                  >
                    <div className="relative">
                      <select
                        id="floating_outline"
                        className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                        placeholder=" "
                      >
                        <option>Claim Type</option>
                        <option>1</option>
                        <option>2</option>
                        <option>3</option>
                      </select>
                      <label
                        for="floating_outlined"
                        className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                      >
                        Claim Tyle
                      </label>
                    </div>
                  </div>
                </div>
                <div className="flex gap-4">
                  <div className="MuiFormControl-root MuiTextField-root flex-1">
                    <div className="relative">
                      <input
                        datepicker
                        type="date"
                        id="floating_outlined"
                        className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                        placeholder=" "
                      />

                      <label
                        for="floating_outlined"
                        className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                      >
                        Select Date
                      </label>
                    </div>
                  </div>
                  <div className="MuiFormControl-root MuiTextField-root flex-1">
                    <div className="relative">
                      <input
                        type="Number"
                        id="floating_outlined"
                        className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                        placeholder=" "
                      />
                      <label
                        for="floating_outlined"
                        className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                      >
                        Claim Name
                      </label>
                    </div>
                  </div>
                </div>
                <div className="flex gap-4">
                  <div className="MuiFormControl-root MuiTextField-root flex-1">
                    <div className="relative">
                      <input
                        type="Number"
                        id="floating_outlined"
                        className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                        placeholder=" "
                      />
                      <label
                        for="floating_outlined"
                        className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                      >
                        Contact #
                      </label>
                    </div>
                  </div>
                  <div className="MuiFormControl-root MuiTextField-root flex-1">
                    <div className="relative">
                      <input
                        type="Number"
                        id="floating_outlined"
                        className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                        placeholder=" "
                      />
                      <label
                        for="floating_outlined"
                        className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                      >
                        Email Address
                      </label>
                    </div>
                  </div>
                </div>
                <div className="flex gap-4">
                  <div className="MuiFormControl-root MuiTextField-root flex-1">
                    <div className="relative">
                      <input
                        type="Number"
                        id="floating_outlined"
                        className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                        placeholder=" "
                      />
                      <label
                        for="floating_outlined"
                        className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                      >
                        Description
                      </label>
                    </div>
                  </div>
                </div>
                <div className="flex gap-4">
                  <div className="MuiFormControl-root MuiTextField-root flex-1">
                    <div className="relative">
                      <input
                        type="Number"
                        id="floating_outlined"
                        className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                        placeholder=" "
                      />
                      <label
                        for="floating_outlined"
                        className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                      >
                        Contents
                      </label>
                    </div>
                  </div>
                </div>
                <div className="flex gap-4">
                  <div className="MuiFormControl-root MuiTextField-root flex-1">
                    <div className="relative">
                      <input
                        type="Number"
                        id="floating_outlined"
                        className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                        placeholder=" "
                      />
                      <label
                        for="floating_outlined"
                        className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                      >
                        Declared Value PKR
                      </label>
                    </div>
                  </div>
                  <div className="MuiFormControl-root MuiTextField-root flex-1">
                    <div className="relative">
                      <input
                        type="Number"
                        id="floating_outlined"
                        className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                        placeholder=" "
                      />
                      <label
                        for="floating_outlined"
                        className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                      >
                        Claimed Amount PKR
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="flex flex-col justify-center items-center mt-[1rem] ">
          <div className="flex flex-col gap-3 p-8 mb-3 shadow-card text-sm w-[45rem] rounded-md transition-all duration-500">
            <h2 className="font-bold text-[1.1rem]">Insurance</h2>
            <div className="flex gap-4">
              <div className="MuiFormControl-root">
                <h3 className="mb-4 font-semibold text-gray-900 dark:text-white">
                  Is your shipment is insured
                </h3>

                <div className="flex">
                  <div className="flex items-center mr-4">
                    <input
                      id="inline-radio"
                      type="radio"
                      value=""
                      name="inline-radio-group"
                      className="w-5 h-5 accent-red"
                    />
                    <label
                      for="inline-radio"
                      className="ml-2 text-lg font-medium text-gray-900 dark:text-gray-300"
                    >
                      Yes
                    </label>
                  </div>
                  <div className="flex items-center mr-4">
                    <input
                      id="inline-2-radio"
                      type="radio"
                      value=""
                      name="inline-radio-group"
                      className="w-5 h-5 accent-red-500"
                    />
                    <label
                      for="inline-2-radio"
                      className="ml-2 text-lg font-medium text-gray-900 dark:text-gray-300"
                    >
                      No
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="flex flex-col justify-center items-center mt-[1rem] ">
          <div className="flex flex-col gap-3 p-8 mb-3 shadow-card text-sm w-[45rem] rounded-md transition-all duration-500">
            <h2 className="font-bold text-[1.1rem]">Bank Account Details</h2>
            <div className="flex gap-4 mt-4">
              <div className="flex-1 flex flex-col gap-4">
                <div className="flex gap-4">
                  <div className="MuiFormControl-root MuiTextField-root flex-1">
                    <div className="relative">
                      <input
                        type="Number"
                        id="floating_outlined"
                        className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                        placeholder=" "
                      />
                      <label
                        for="floating_outlined"
                        className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                      >
                        (IBAN))
                      </label>
                    </div>
                  </div>
                  <div className="MuiFormControl-root MuiTextField-root flex-1">
                    <div className="relative">
                      <input
                        type="Number"
                        id="floating_outlined"
                        className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                        placeholder=" "
                      />
                      <label
                        for="floating_outlined"
                        className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                      >
                        Bank Name
                      </label>
                    </div>
                  </div>
                </div>
                <div className="flex gap-4">
                  <div className="MuiFormControl-root MuiTextField-root flex-1">
                    <div className="relative">
                      <input
                        type="Number"
                        id="floating_outlined"
                        className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                        placeholder=" "
                      />
                      <label
                        for="floating_outlined"
                        className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                      >
                        Branch Code
                      </label>
                    </div>
                  </div>
                  <div className="MuiFormControl-root MuiTextField-root flex-1">
                    <div className="relative">
                      <input
                        type="Number"
                        id="floating_outlined"
                        className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                        placeholder=" "
                      />
                      <label
                        for="floating_outlined"
                        className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                      >
                        Bank Account Title
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="flex flex-col justify-center items-center mt-[1rem] ">
          <div className="flex flex-col gap-3 p-8 mb-3 shadow-card text-sm w-[45rem] rounded-md transition-all duration-500">
            <h2 className="font-bold text-[1.1rem]">Attachments</h2>
            <div className="flex gap-4">
              <div
                className="MuiFormControl-root flex-1"
                inputprops="[object Object]"
                inputlabelprops="[object Object]"
              ></div>
            </div>
            <div className="flex gap-4">
              <div className="file-upload-wrapper" data-text="CNIC">
                <i className="Home Icon">{/* <AttachFile color="dark" /> */}</i>
                <input
                  name="file-upload-field"
                  type="file"
                  className="file-upload-field"
                  value=""
                />
              </div>
            </div>
            <div className="flex gap-4">
              <div className="file-upload-wrapper" data-text="Original Invoice">
                <i className="Home Icon">{/* <AttachFile color="dark" /> */}</i>
                <input
                  name="file-upload-field"
                  type="file"
                  className="file-upload-field"
                  value=""
                />
              </div>
            </div>
            <div className="flex gap-4">
              <div className="file-upload-wrapper" data-text="Booking Slip">
                <i className="Home Icon">{/* <AttachFile color="dark" /> */}</i>
                <input
                  name="file-upload-field"
                  type="file"
                  className="file-upload-field"
                  value=""
                />
              </div>
            </div>
            <div className="flex gap-4">
              <div className="note">
                Note: Your claim will be processed as per trems of carriage as
                mentioned on your Airwatbill
              </div>
            </div>
          </div>
        </div>

        <div className="flex flex-col justify-center items-center mt-[1rem] ">
          <div className="flex gap-4 w-[45rem]">
            <div className="g-recaptcha">
              <ReCAPTCHA
                // sitekey="6Le3utQhAAAAAOvAHs5QXdniSKLmvtTn0vM7GUzA"
                sitekey={process.env.REACT_APP_CAPTCH}
                // sitekey="6LeQwecjAAAAACyoUlVWbSpm-LaXakw8mAyWNfM6"
                onChange={onChange}
              />
            </div>
          </div>
        </div>

        <div className="flex flex-col justify-center items-center mt-[1rem] ">
          <button
            onClick={submitHandler}
            className="mt-3 text-white bg-[#D40511] border border-[#F21E26] w-[45rem] rounded-md mt-1 p-1 h-[2.5rem] text-sm hover:bg-[#F21E26] hover:text-white transition-all duration-500"
          >
            Submit
          </button>
        </div>
      </div>
      {/* <!-- Form --> */}
    </div>
  );
};

export default ClaimForm;
